module.exports = __webpack_public_path__ + "static/media/Cathedral1.e7270320.jpg";